module.exports = __webpack_public_path__ + "static/hyperv_9.2972b40f.jpg";